import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../react-app-env';

const _selectCaseInitQuery = (id: string) => ({
  cases_by_pk: params(
    { id: rawString(id) },
    {
      id: types.string,
      accession_id: types.string,
      created_at: types.string,
      mrn: types.string,
      documents: [
        {
          id: types.string,
          document_name: types.string,
          case_id: types.string,
          created_at: types.string,
        },
      ],
      reports_text: types.string,
      reports_file_id: types.string,
      enum_case_priority: {
        description: types.string,
      },
      created_by_user: {
        full_name: types.string,
      },
      patient: {
        id: types.string,
        nhs_id: types.string,
        dob: types.string,
      },
      organisation: {
        id: types.string,
        name: types.string,
      },
      lab: {
        id: types.string,
        name: types.string,
      },
      surgical_pathway_versions: [
        {
          category: {
            id: types.string,
            name: types.string,
            speciality: {
              name: types.string,
            },
          },
          surgical_pathways: types.custom<{ title: string; label: string; component_type?: string }[]>(),
          note: types.string,
        },
      ],
      pots: [
        {
          id: types.string,
          name: types.string,
          pathway: types.custom<{ title: string; label: string }[]>(),
          speciality_category_id: types.string,
          note: types.string,
        },
      ],
      case_events: params(
        {
          limit: 1,
          where: { event_type: { _eq: 'CASE_DATA' } },
        },
        [
          {
            event_data: types.custom<{ patient: { first_name: string; last_name: string } }>(),
          },
        ]
      ),
    }
  ),
});

type X = Unpacked<typeof _selectCaseInitQuery>;
export type Case = X['cases_by_pk'];
export type PathwayVersion = Case['surgical_pathway_versions'][0];
export type Pot = Case['pots'][0];

export const selectCaseInitQuery = (id: string) => gql`
  ${query(_selectCaseInitQuery(id))}
`;
